<template>
  <div id="PaymentReminderNotice">
    <section class="content-area">
      <div class="title">
        親愛的要助人<span class="red">{{ data.pay_name }}</span>您好:
      </div>

      <div class="description">
        <p>這是重要的通知函，請您百忙之中盡速處理</p>

        <p>
          經資料顯示契約編號:<span class="red">{{ data.number }}</span>
          互助人:<span class="red">{{ data.member_name }}</span>
          <span class="red">{{ Number(data.unpay_bill_1.split('-')[0]) - 1911 }}</span>.
          <span class="red">{{ data.unpay_bill_1.split('-')[1] }}</span>/
          <span class="red">{{ Number(data.unpay_bill_2.split('-')[0]) - 1911 }}</span>.
          <span class="red">{{ data.unpay_bill_2.split('-')[1] }}</span><br />
          互助費尚未繳交,應繳金額：<span class="red">{{ data.amount }}</span>元(含手續費）
        </p>

        <p>
          繳費截止日是
          <span class="red">{{ convertRocDate(data.dead_line, false, true).year }}</span>年
          <span class="red">{{ convertRocDate(data.dead_line, false, true).month }}</span>月
          <span class="red">{{ convertRocDate(data.dead_line, false, true).day }}</span>日
        </p>

        <p>若未在繳款期限內繳交，恐損您互助契約的權益，特此通知！</p>
      </div>
    </section>

    <section class="company-area">
      <p>客務專線：04-23149111</p>

      <p>若收到通知單前已繳納請勿理會本通知</p>

      <p>如需要辦理停效或墊繳請連絡客服我們將為您服務</p>

      <p class="slogan">永豐網路平台關心您與您的家人</p>
    </section>

    <section class="date-area">
      <p>
        <span>中</span>
        <span>華</span>
        <span>民</span>
        <span>國</span>
        <span class="red">{{ getTodayDate(true, true).year }}</span>年
        <span class="red">{{ getTodayDate(true, true).month }}</span>月
        <span class="red">{{ getTodayDate(true, true).day }}</span>日
      </p>
    </section>
  </div>
</template>

<script>
import { convertRocDate, getTodayDate } from "@/models/HELPERS/common.js";

export default {
  name: 'PaymentReminderNotice',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => {}
    },
  },
  watch: {
    'data.id': {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          // this.generateBarcode();
        });
      },
      immediate: false
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  mounted() {
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      // this.$nextTick(() => {
      // });
    },
    convertRocDate,
    getTodayDate
  }
}
</script>

<style lang="scss" scoped>
* {
  font-family: DFKai-sb;
}

#PaymentReminderNotice {
  width: 794px;
  height: 560px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  p {
    margin: 0;
  }
  .red {
    color: red;
  }
  .content-area {
    width: 100%;
    // background: #ffffcc;
    // padding: 10px;
    .title {
      font-size: 26px;
      font-weight: 500;
    }
    .description {
      margin-top: 15px;
      font-size: 26px;
      font-weight: 500;
      line-height: 2;
    }
  }
  .company-area {
    width: 100%;
    margin-top: 30px;
    font-size: 18px;
    font-weight: bold;
    margin-top: auto;
    .slogan {
      margin-top: 10px;
      font-weight: 500;
      text-align: right;
      font-size: 22px;
    }
  }
  .date-area {
    font-size: 26px;
    font-weight: 500;
    margin-top: 30px;
    p {
      display: flex;
      justify-content: space-between;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/PrintTemplate/PaymentReminderNotice.vue